import React from "react";
import { Dimmer } from "semantic-ui-react";

const CustomLoader = () => {
  return (
    <Dimmer active={true} inverted style={{ position: "fixed" }}>
      {/* <img src={logo} style={{ width: "20vw" }} alt="loading..." /> */}
      <div
        style={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div class="lds-roller">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </Dimmer>
  );
};

export default CustomLoader;
